import React from "react";
import {Box, Button, Typography, useMediaQuery} from "@mui/material";
import {useTranslation} from "react-i18next";
import {CircleAlert} from "lucide-react";
import {theme} from "../../../../../config/design/theme";
import {truncate} from "../../../../../config/values";

const CharityBanner = ({ onClose }) => {
    const { t } = useTranslation();
    const charityName = localStorage.getItem("charity_name");
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md')); // Adjust breakpoint as needed


    if (!charityName) return null;

    return (
        <Box
            sx={{
                position: "fixed",
                bottom: 5,
                left: "50%",
                transform: "translateX(-50%)",
                width: "90%",
                backgroundColor: '#b5dfff',
                color: "#111",
                padding: "15px 40px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                zIndex: 1000,
                border:" 3px solid #0090ff",
                borderRadius:16,
                [theme.breakpoints.down('md')]: {
                    bottom: 60,
                    padding: "10px 20px",

                },
            }}
        >
            <Typography variant="body1" className="flex-direction flex-column-md">

                {
                    !isMobile &&
                    <CircleAlert className="lucide-large"/>
                }
                <Typography>{t('youAreBuyingFor')}:</Typography>
                <strong>{truncate(charityName,20)}</strong>
            </Typography>
            <Button
                variant="outlined"
                color="primary"
                onClick={onClose}
                sx={{ ml: 2 }}
            >
                Close
            </Button>
        </Box>
    );
};

export default CharityBanner;
